import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Navbar.css";
import "../../App.css";
import logo from "../../assets/xten-logo.png";
import { Link, useLocation } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import Menu from "@mui/material/Menu";

function Navbar() {
  const [isMobile, setIsMobile] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { t, i18n } = useTranslation();
  const location = useLocation();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const [iotAnchorEl, setiotAnchorEl] = React.useState(null);
  // const [productAnchorEl, setProductAnchorEl] = React.useState(null);
  // const [serviceAnchorEl, setServiceAnchorEl] = React.useState(null);
  // const [aboutUsAnchorEl, setAboutUsAnchorEl] = React.useState(null);
  const [newsAnchorEl, setNewsAnchorEl] = React.useState(null);
  const logoRef = useRef(null);
  const menuRef = useRef(null);
  const consoleRef = useRef(null);

  useEffect(() => {
    // ฟังก์ชันตรวจสอบขนาดหน้าจอ
    const handleResize = () => {
      if (window.screen.width <= 932) {
        setIsMobile(true); // ถ้าเป็นมือถือหรือขนาดเล็ก
      } else {
        setIsMobile(false); // ถ้าเป็นขนาดใหญ่
      }
    };

    // เรียกใช้เมื่อแสดงผลครั้งแรกและเวลาเปลี่ยนขนาดหน้าจอ
    handleResize();
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => window.removeEventListener("resize", handleResize);
  });

  // function handleClick(event) {
  //   if (logoRef.current) {
  //     setProductAnchorEl(null);
  //     setiotAnchorEl(null);
  //     setServiceAnchorEl(null);
  //     setAboutUsAnchorEl(null);
  //     setNewsAnchorEl(null);
  //     setAnchorEl(logoRef.current);
  //     setIsMenuOpen(true);
  //   }
  // }

  // function handleClose() {
  //   setAnchorEl(null);
  //   setIsMenuOpen(false);
  // }

  // function handleiotClick(event) {
  //   if (logoRef.current) {
  //     setProductAnchorEl(null);
  //     setAnchorEl(null);
  //     setServiceAnchorEl(null);
  //     setAboutUsAnchorEl(null);
  //     setNewsAnchorEl(null);
  //     setiotAnchorEl(logoRef.current);
  //     setIsMenuOpen(true);
  //   }
  // }

  // function handleiotClose() {
  //   setiotAnchorEl(null);
  //   setIsMenuOpen(false);
  // }

  // function handleproductClick(event) {
  //   if (logoRef.current) {
  //     setAnchorEl(null);
  //     setiotAnchorEl(null);
  //     setServiceAnchorEl(null);
  //     setNewsAnchorEl(null);
  //     setAboutUsAnchorEl(null);
  //     setProductAnchorEl(logoRef.current);
  //     setIsMenuOpen(true);
  //   }
  // }

  // function handleproductClose() {
  //   setProductAnchorEl(null);
  //   setIsMenuOpen(false);
  // }

  // function handleservicesClick(event) {
  //   if (logoRef.current) {
  //     setAnchorEl(null);
  //     setiotAnchorEl(null);
  //     setProductAnchorEl(null);
  //     setAboutUsAnchorEl(null);
  //     setNewsAnchorEl(null);
  //     setServiceAnchorEl(logoRef.current);
  //     setIsMenuOpen(true);
  //   }
  // }

  // function handleservicesClose() {
  //   setServiceAnchorEl(null);
  //   setIsMenuOpen(false);
  // }

  // function handleaboutUsClick(event) {
  //   if (logoRef.current) {
  //     setAnchorEl(null);
  //     setiotAnchorEl(null);
  //     setProductAnchorEl(null);
  //     setServiceAnchorEl(null);
  //     setNewsAnchorEl(null);
  //     setAboutUsAnchorEl(logoRef.current);
  //     setIsMenuOpen(true);
  //   }
  // }

  // function handleaboutUsClose() {
  //   setAboutUsAnchorEl(null);
  //   setIsMenuOpen(false);
  // }

  function handleNewsClick(event) {
    if (logoRef.current) {
      // setAnchorEl(null);
      // setiotAnchorEl(null);
      // setProductAnchorEl(null);
      // setServiceAnchorEl(null);
      // setAboutUsAnchorEl(null);
      setNewsAnchorEl(logoRef.current);
      setIsMenuOpen(true);
    }
  }

  function handleNewsClose() {
    setNewsAnchorEl(null);
    setIsMenuOpen(false);
  }

  // Scroll to top when the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Detect the browser's language
  useEffect(() => {
    const browserLanguage = navigator.language || navigator.languages[0];
    if (browserLanguage.startsWith("th")) {
      setSelectedLanguage("TH");
      i18n.changeLanguage("th");
    } else {
      setSelectedLanguage("EN");
      i18n.changeLanguage("en");
    }
  }, [i18n]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        consoleRef.current &&
        !consoleRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleChange = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang === "en" ? "EN" : "TH");
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
    setIsMenuOpen(false);
  };

  return (
    <>
      {!isMobile && (
        <div>
          <div className="bg-navbar">
            <div className="content-navbar">
              <div className="header">
                <Link to="/">
                  <img
                    src={logo}
                    alt=""
                    className="navbar-logo"
                    ref={logoRef}
                  />
                </Link>

                <div
                  className="menu-select"
                  // onClick={handleClick}
                  // onMouseEnter={handleClick}
                  id="SUSTAIN-menu"
                >
                  {t("navbar_sustain_x")}
                </div>

                {/* <Menu
                  id="SUSTAIN-menu"
                  style={{ cursor: "pointer" }}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  MenuListProps={{ onMouseLeave: handleClose }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      marginTop: "-50px",
                      marginLeft: "0px",
                      marginRight: "380px",
                      position: "relative",
                    },
                  }}
                >
                  <div className="menu-select-card">
                    <Link to="/sustain-x" style={{ textDecoration: "none" }}>
                      <div className="box-header-menu" onClick={handleClose}>
                        <div className="header-menu">
                          Browse SUSTAIN-X Platform
                        </div>
                        <div className="symbol">{">"}</div>
                      </div>
                    </Link>
                    <div className="menu-sustain-x-select">
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">Menu #1</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">Menu #2</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">Menu #3</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">Menu #4</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                    </div>
                  </div>
                </Menu> */}

                <div
                  id="IoT-menu"
                  className="menu-select"
                  // onClick={handleiotClick}
                  // onMouseEnter={handleiotClick}
                >
                  {t("IoT_Solution_Platform")}
                </div>

                {/* <Menu
                  id="IoT-menu"
                  style={{ cursor: "pointer" }}
                  anchorEl={iotAnchorEl}
                  open={Boolean(iotAnchorEl)}
                  onClose={handleiotClose}
                  MenuListProps={{ onMouseLeave: handleiotClose }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      marginTop: "-50px",
                      marginLeft: "0px",
                      marginRight: "380px",
                      position: "relative",
                    },
                  }}
                >
                  <div className="menu-select-card">
                    <Link
                      to="/iot-solutions"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="box-header-menu" onClick={handleiotClose}>
                        <div className="header-menu">
                          View All IoT/IT Solution Platform
                        </div>
                        <div className="symbol">{">"}</div>
                      </div>
                    </Link>
                    <div className="menu-iot-column-select">
                      <div className="menu-sustain-x-select">
                        <Link
                          className="box-menu-sustain-x-select"
                          to="/iot-solutions#iot-blog"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="box-menu-head">
                            IoT/IT Solutions Blog
                          </div>
                          <div className="box-menu-sub">
                            Vorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis. Class aptent taciti sociosqu ad
                            litora torquent per conubia nostra, per inceptos
                            himenaeos. Curabitur tempus urna at turpis
                            condimentum lobortis.
                          </div>
                        </Link>

                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            IoT/IT Solutions List
                          </div>
                          <div className="box-menu-sub">
                            Gorem ipsum dolor sit amet, consectetur adipiscing
                            elit.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Energy Management System
                          </div>
                          <div className="box-menu-sub">
                            Korem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis. Class aptent taciti sociosqu ad
                            litora torquent per conubia nostra, per inceptos
                            himenaeos. Curabitur tempus urna at turpis
                            condimentum lobortis. Ut commodo efficitur neque.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Billing Management System
                          </div>
                          <div className="box-menu-sub">
                            Horem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                      </div>
                      <div
                        className="menu-sustain-x-select"
                        style={{ paddingTop: "0px" }}
                      >
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Air Quality Management Platform
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Fire Alarm Management Platform
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            A/C Optimized Platform
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Wastewater Treatment Platform
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                      </div>
                      <div
                        className="menu-sustain-x-select"
                        style={{ paddingTop: "0px" }}
                      >
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Rectifier Management System
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">OEE Platform</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Solar Plant Management
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Vehicle Tracking Management
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                      </div>
                      <div
                        className="menu-sustain-x-select"
                        style={{ paddingTop: "0px" }}
                      >
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Smart Meeting Room
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Carbon Footprint Platform
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="w-25"></div>
                        <div className="w-25"></div>
                      </div>
                    </div>
                  </div>
                </Menu> */}

                <div
                  id="IoT-menu"
                  className="menu-select"
                  // onClick={handleproductClick}
                  // onMouseEnter={handleproductClick}
                >
                  {t("navbar_product")}
                </div>
                {/* 
                <Menu
                  id="IoT-menu"
                  style={{ cursor: "pointer" }}
                  anchorEl={productAnchorEl}
                  open={Boolean(productAnchorEl)}
                  onClose={handleproductClose}
                  MenuListProps={{ onMouseLeave: handleproductClose }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      marginTop: "-50px",
                      marginLeft: "0px",
                      marginRight: "380px",
                      position: "relative",
                    },
                  }}
                >
                  <div className="menu-select-card">
                    <Link to="/all-product" style={{ textDecoration: "none" }}>
                      <div
                        className="box-header-menu"
                        onClick={handleproductClose}
                      >
                        <div className="header-menu">View All Products</div>
                        <div className="symbol">{">"}</div>
                      </div>
                    </Link>
                    <div className="menu-iot-column-select">
                      <div className="menu-sustain-x-select">
                        <Link
                          className="box-menu-sustain-x-select"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="box-menu-head">XTEN All Products</div>
                          <div className="box-menu-sub">
                            Vorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis. Class aptent taciti sociosqu ad
                            litora torquent per conubia nostra, per inceptos
                            himenaeos. Curabitur tempus urna at turpis
                            condimentum lobortis.
                          </div>
                        </Link>

                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Products List</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Power Meter</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Water Meter</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                      </div>
                      <div
                        className="menu-sustain-x-select"
                        style={{ paddingTop: "0px" }}
                      >
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">
                            Air Quality Sensor
                          </div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">CCTV</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Conference Room</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Lighting</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                      </div>
                      <div
                        className="menu-sustain-x-select"
                        style={{ paddingTop: "0px" }}
                      >
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Parking</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">UPS</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="w-25"></div>
                        <div className="w-25"></div>
                      </div>
                    </div>
                  </div>
                </Menu> */}

                <div
                  id="IoT-menu"
                  className="menu-select"
                  // onClick={handleservicesClick}
                  // onMouseEnter={handleservicesClick}
                >
                  <div>{t("navbar_services")}</div>
                </div>

                {/* <Menu
                  id="IoT-menu"
                  style={{ cursor: "pointer" }}
                  anchorEl={serviceAnchorEl}
                  open={Boolean(serviceAnchorEl)}
                  onClose={handleservicesClose}
                  MenuListProps={{ onMouseLeave: handleservicesClose }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      marginTop: "-50px",
                      marginLeft: "0px",
                      marginRight: "380px",
                      position: "relative",
                    },
                  }}
                >
                  <div className="menu-select-card">
                    <Link to="/all-service" style={{ textDecoration: "none" }}>
                      <div
                        className="box-header-menu"
                        onClick={handleservicesClose}
                      >
                        <div className="header-menu">View All Services</div>
                        <div className="symbol">{">"}</div>
                      </div>
                    </Link>
                    <div className="menu-iot-column-select">
                      <div className="menu-sustain-x-select">
                        <Link
                          className="box-menu-sustain-x-select"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="box-menu-head">XTEN All Services</div>
                          <div className="box-menu-sub">
                            Vorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis. Class aptent taciti sociosqu ad
                            litora torquent per conubia nostra, per inceptos
                            himenaeos. Curabitur tempus urna at turpis
                            condimentum lobortis.
                          </div>
                        </Link>

                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Survey</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Prototype Design</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Wiring</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                      </div>
                      <div
                        className="menu-sustain-x-select"
                        style={{ paddingTop: "0px" }}
                      >
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Engineering</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.{" "}
                          </div>
                        </div>
                        <div className="box-menu-sustain-x-select">
                          <div className="box-menu-head">Configuration</div>
                          <div className="box-menu-sub">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc vulputate libero et velit interdum, ac
                            aliquet odio mattis.
                          </div>
                        </div>
                        <div className="w-25"></div>
                        <div className="w-25"></div>
                      </div>
                    </div>
                  </div>
                </Menu> */}

                <div
                  id="IoT-menu"
                  className="menu-select"
                  // onClick={handleaboutUsClick}
                  // onMouseEnter={handleaboutUsClick}
                >
                  {t("navbar_about_as")}
                </div>

                {/* <Menu
                  style={{ cursor: "pointer" }}
                  anchorEl={aboutUsAnchorEl}
                  open={Boolean(aboutUsAnchorEl)}
                  onClose={handleaboutUsClose}
                  MenuListProps={{ onMouseLeave: handleaboutUsClose }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      marginTop: "-50px",
                      marginLeft: "0px",
                      marginRight: "380px",
                      position: "relative",
                    },
                  }}
                >
                  <div className="menu-select-card">
                    <Link to="/about-us" style={{ textDecoration: "none" }}>
                      <div
                        className="box-header-menu"
                        onClick={handleaboutUsClose}
                      >
                        <div className="header-menu">View All About us</div>
                        <div className="symbol">{">"}</div>
                      </div>
                    </Link>
                    <div className="menu-sustain-x-select">
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">All About us</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">News</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">Activity</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                      <div className="box-menu-sustain-x-select">
                        <div className="box-menu-head">Blog</div>
                        <div className="box-menu-sub">
                          Horem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis.
                        </div>
                      </div>
                    </div>
                  </div>
                </Menu> */}

                <div
                  id="IoT-menu"
                  className="menu-select"
                  onClick={handleNewsClick}
                  onMouseEnter={handleNewsClick}
                >
                  {t("navbar_new_event")}
                </div>

                <Menu
                  style={{ cursor: "pointer" }}
                  anchorEl={newsAnchorEl}
                  open={Boolean(newsAnchorEl)}
                  onClose={handleNewsClose}
                  MenuListProps={{ onMouseLeave: handleNewsClose }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      marginTop: "-50px",
                      marginLeft: "0px",
                      marginRight: "380px",
                      position: "relative",
                    },
                  }}
                >
                  <div className="menu-select-card">
                    <Link
                      to={{
                        pathname: "/news&events",
                        state: "All", // ส่ง selectedType หรือค่าที่ต้องการ
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        className="box-header-menu"
                        onClick={handleNewsClose}
                      >
                        <div className="header-menu">
                        {t("navbar_head_all_main")}
                          
                        </div>
                        <div className="symbol">{">"}</div>
                      </div>
                    </Link>
                    <div className="menu-sustain-x-select">
                      <div className="box-menu-sustain-x-select">
                      <Link
                        to={{
                          pathname: "/news&events",
                        }}
                        state={{ selectedType: "All" }}
                        style={{ textDecoration: "none" }}
                      >
                        
                          <div className="box-menu-head"> {t("navbar_head_all")} </div>
                          <div className="box-menu-sub">
                            {t("navbar_detail_all")}
                        </div>
                      </Link>
                      </div>
                      <div className="box-menu-sustain-x-select">
                      <Link
                        to={{
                          pathname: "/news&events",
                        }}
                        state={{ selectedType: "News" }}
                        style={{ textDecoration: "none" }}
                      >
                        
                          <div className="box-menu-head">{t("navbar_head_news")}</div>
                          <div className="box-menu-sub">
                            {t("navbar_detail_news")}
                          </div>
                      </Link>
                      </div>
                      
                      <div className="box-menu-sustain-x-select">
                      <Link
                        to={{
                          pathname: "/news&events",
                        }}
                        state={{ selectedType: "Activity" }}
                        style={{ textDecoration: "none" }}
                      >
                        
                          <div className="box-menu-head">{t("navbar_head_activity")}</div>
                          <div className="box-menu-sub">
                            {t("navbar_detail_activity")}
                          </div>
                      </Link>
                      </div>
                      
                      <div className="box-menu-sustain-x-select">
                        <Link
                          to={{
                            pathname: "/news&events",
                          }}
                          state={{ selectedType: "Blog" }}
                          style={{ textDecoration: "none" }}
                        >
                            <div className="box-menu-head">{t("navbar_head_blog")}</div>
                            <div className="box-menu-sub">
                              {t("navbar_detail_blog")}
                            </div>
                        </Link>
                      </div>
                      
                    </div>
                  </div>
                </Menu>
              </div>
              <div className="box-null"></div>
              <div className="console">
                <div
                  style={{
                    width: "max-content",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={scrollToBottom}
                >
                  {t("navbar_contact")}
                </div>
                <div className="language-selector">
                  <div
                    className="language-title"
                    onMouseEnter={() => setIsDropdownOpen(true)}
                    onMouseLeave={() => setIsDropdownOpen(false)}
                  >
                    {selectedLanguage}{" "}
                    <FaChevronDown className="fa-icon-down" />
                  </div>
                  {isDropdownOpen && (
                    <div
                      className="dropdown"
                      onMouseEnter={() => setIsDropdownOpen(true)}
                      onMouseLeave={() => setIsDropdownOpen(false)}
                    >
                      {selectedLanguage === "TH" ? (
                        <div
                          style={{ color: "black" }}
                          onClick={() => handleChange("en")}
                        >
                          EN
                        </div>
                      ) : (
                        <div
                          style={{ color: "black" }}
                          onClick={() => handleChange("th")}
                        >
                          TH
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {/* <div className="console-button">
                  <span>Console</span>
                </div> */}
              </div>
            </div>
          </div>

          <div className={`body-content ${isMenuOpen ? "blur" : ""}`}></div>

          {isMenuOpen && <div className="content-blur" />}
        </div>
      )}

      {isMobile && (
        <div>
          <div className="mobile-navbar">
            <div className="mobile-navbar-logo">
              <Link to="/" className="mobile-navbar-logo">
                <img src={logo} alt="" className="navbar-logo" ref={logoRef} />
              </Link>
            </div>
            <div className="mobile-console" ref={consoleRef}>
              <div>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  <div style={{ fontSize: "24px", color: "black" }}>☰</div>
                </div>

                {isMenuOpen && (
                  <div className="mobile-dropdown-menu" ref={menuRef}>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t("navbar_sustain_x")}
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t("IoT_Solution_Platform")}
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t("navbar_product")}
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t("navbar_services")}
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t("navbar_about_as")}
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <Link
                        to="/news&events"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        {t("navbar_new_event")}
                      </Link>
                    </div>

                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                    >
                      <div
                        className="mobile-language-title"
                        onClick={() => {
                          const newLanguage =
                            selectedLanguage === "TH" ? "en" : "th";
                          handleChange(newLanguage);
                          setIsMenuOpen(false);
                        }}
                      >
                        {selectedLanguage}
                      </div>
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        color: "#000",
                      }}
                      onClick={() => {
                        scrollToBottom();
                        setIsMenuOpen(false);
                      }}
                    >
                      {t("navbar_contact")}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
